import UserPattern from './U.Pattern';

export default UserPattern
export { UserPattern as Base }
